export default __webpack_public_path__ + "static/media/Posicion.f8b3de1b.PNG";